import * as types from "../actions/types";


const initialState = {
  personnelList: [],
  personnelCount: 0,
  person: null,
  personTabData: {},        // { main: {...}, education: [...], ... }
  deletionsTracker: {},     // { education: [id1], awards: [id2], ... }
  personFiles: [],
  personnelRolesList: [],
  personnelAttestationsList: [],
  personnelLessonsList: [],
  loading: false
};


export default function personnel(state = initialState, action) {
  switch (action.type) {

    case types.GET_PERSONNEL_LIST:
      return {
        ...state,
        personnelList: action.payload
      };

    case types.SET_PERSONNEL_COUNT:
      return {
        ...state,
        personnelCount: action.payload
      };

    case types.GET_PERSON:
      return {
        ...state,
        person: action.payload,
        personTabData: {},      // Очищаем данные табов при загрузке нового сотрудника
        deletionsTracker: {}    // Очищаем трекер удалений
      };

    case types.GET_PERSON_TABLE:
      return {
        ...state,
        personTable: action.payload
      };

    case types.GET_PERSON_TAB_DATA:
      return {
        ...state,
        personTabData: {
          ...state.personTabData,
          [action.payload.tab]: action.payload.data
        }
      };
    case types.GET_PERSON_DROPDOWN:
      return {
        ...state,
        personDropdawn: {
          ...state.personDropdawn,
          [action.payload.field]: action.payload.values
        }
      };

    case types.ADD_PERSONNEL_DELETION:
      const { apiTab, itemId } = action.payload;
      return {
        ...state,
        deletionsTracker: {
          ...state.deletionsTracker,
          [apiTab]: [...(state.deletionsTracker[apiTab] || []), itemId]
        }
      };

    case types.CLEAR_PERSONNEL_DELETIONS:
      return {
        ...state,
        deletionsTracker: {}
      };

    case types.GET_PERSON_FILES:
      return {
        ...state,
        personFiles: action.payload
      };

    case types.GET_PERSONNEL_ROLES_LIST:
      return {
        ...state,
        personnelRolesList: action.payload
      };
    case types.GET_PERSONNEL_ALL_ROLES_LIST:
      return {
        ...state,
        personnelAllRolesList: action.payload
      };

    case types.GET_PERSONNEL_ATTESTATIONS_LIST:
      return {
        ...state,
        personnelAttestationsList: action.payload
      };

    case types.GET_PERSONNEL_LESSONS_LIST:
      return {
        ...state,
        personnelLessonsList: action.payload
      };

    case types.SET_PERSONNEL_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    default:
      return state;
  }
}
